// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"be563f4d","453":"1d2bcb10","455":"49d7923c"}[chunkId] + ".chunk.js";
};